var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"part white"},[_vm._v(" part ")])
}
var staticRenderFns = []

export { render, staticRenderFns }